export { makeRumPublicApi } from './boot/rumPublicApi';
export { startRum } from './boot/rum';
export { LifeCycle, LifeCycleEventType } from './domain/lifeCycle';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@datadog/browser-rum-core/esm/index.js
// module id = 1230
// module chunks = 0